import { Skeleton } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { CpWidgetVariantType } from 'api/customer-portal/types';
import { CpSectionWrapper } from 'components/organisms/customer-portal/widgets/common';
import { CpHeroSectionFullBackgroundTitleAndDescWrapper } from 'components/organisms/customer-portal/widgets/hero-section/variants/hero-section-full-background';
import {
  CpLoadingDesc,
  CpLoadingProps,
  CpLoadingTitle,
  TitleAndDesc,
} from '../common';

const FBWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 52px);
  padding-bottom: 7rem;

  @media (max-width: 30em) {
    padding-left: var(--cp-spacing-05);
    padding-right: var(--cp-spacing-05);
  }
`;

const FbImageSkeleton = styled(Skeleton.Image)`
  &.ant-skeleton,
  .ant-skeleton {
    width: 100% !important;
    height: calc(100vh - 52px) !important;
    position: absolute;
  }

  .ant-skeleton-image {
    width: 100% !important;
    height: 100% !important;
  }
`;

const StyledWrapper = styled(CpHeroSectionFullBackgroundTitleAndDescWrapper)`
  justify-content: end;
  padding-left: var(--cp-spacing-10);
  gap: 0;

  @media (max-width: 768px) {
    padding-left: 0;
    padding-right: 0;
    align-items: center;
    justify-content: center;
  }
`;

const FullBackground: React.FC<{
  input: Record<string, unknown>;
}> = ({ input }) => {
  return (
    <FBWrapper>
      <FbImageSkeleton />
      <StyledWrapper>
        <TitleAndDesc
          title={input?.title as string}
          desc={input?.description as string}
        />
      </StyledWrapper>
    </FBWrapper>
  );
};

const ImageSkeleton = styled(Skeleton.Image)`
  &.ant-skeleton,
  .ant-skeleton {
    width: 100% !important;
    height: calc(100vh - 52px) !important;
  }

  .ant-skeleton-image {
    width: 100% !important;
    height: 100% !important;
  }
`;

const IABTitleAndDescWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .ant-skeleton {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${ImageSkeleton} {
    margin-bottom: var(--cp-spacing-06);
    margin-top: var(--cp-spacing-05);
  }
`;

const ImageAtTheBottom: React.FC<{
  input: Record<string, unknown>;
}> = ({ input }) => {
  return (
    <>
      <IABTitleAndDescWrapper>
        <TitleAndDesc
          desc={input?.description as string}
          title={input?.title as string}
        />
      </IABTitleAndDescWrapper>
      <ImageSkeleton />
    </>
  );
};

const ImageAtTheCentre: React.FC<{
  input: Record<string, unknown>;
}> = () => {
  return (
    <>
      <IABTitleAndDescWrapper>
        <>
          <CpLoadingTitle active />
          <ImageSkeleton />
          <CpLoadingDesc active />
        </>
      </IABTitleAndDescWrapper>
    </>
  );
};

export const CpHeroSectionLoading: React.FC<CpLoadingProps> = ({
  input,
  variantType,
  styles,
}) => {
  if (variantType === CpWidgetVariantType.HeroSectionFullBackground) {
    return <FullBackground input={input} />;
  }

  return (
    <CpSectionWrapper
      background={styles?.background as string}
      paddingY={styles?.paddingY as number | undefined}
      className="!cp-max-w-none"
    >
      {variantType === CpWidgetVariantType.HeroSectionWithImageAtBottom ? (
        <ImageAtTheBottom input={input} />
      ) : (
        <ImageAtTheCentre input={input} />
      )}
    </CpSectionWrapper>
  );
};
